import reportDesign from './src/index';
import Report from './src/Report';
import { updateConfig } from './src/utils/request';
/* istanbul ignore next */
reportDesign.install = function (Vue) {
    Vue.component(reportDesign.name, reportDesign);
};

Report.install = function (Vue) {
    Vue.component(Report.name, Report);
};

export default {
    reportDesign,
    Report,
    updateConfig
};
